<template>
  <read_layout
    :backto="`/mag/${brandCode}/${issueId}`"
    :title="issueData.mgName"
    @caleclick="switchSilder"
  >
    <loading :active.sync="loading" loader="bars" color="#00ab00"></loading>
    <div :class="full ? 'fullscreen' : 'pager'">
      <div class="sizebar">
        <vueslider v-model="size" :min="20" />
      </div>
      <span class="actable" @click="pre">
        <span :class="haspre || 'hidden'" class="iconfont iconpre"></span>
      </span>

      <image-loader
        @loaded="initscale"
        id="cover"
        @dblclick="swithFull"
        class="magcontent"
        :src="cover"
        :height="coverheight"
        width="auto"
      />
      <span class="actable" @click="next">
        <span :class="hasnext || 'hidden'" class="iconfont iconnext"></span>
      </span>
    </div>
    <silder
      :show.sync="showsilder"
      :brandCode="brandCode"
      @close="switchSilder"
    ></silder>
    <!-- <bottom
      v-if="current.mnId"
      :show="pageNo > -1"
      :title="current.title"
      :magname="current.mgName"
      :issueno="current.issueNo"
      :hcontent="current.htmlContent"
    ></bottom> -->
  </read_layout>
</template>

<script>
import ReadLayout from "../components/_layout/read_layout";
import Silder from "../components/Silder";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
// import BottomSilder from "../components/BottomSilder";
import { getCacheIssue, cacheIssue } from "../libs/utils";
import { get } from "../libs/request";
import { API, bookAPI } from "../libs/consts";
import { head } from "../libs/bookRequest";

export default {
  name: "ReadLayout",
  components: {
    read_layout: ReadLayout,
    silder: Silder,
    // bottom: BottomSilder,
    vueslider: VueSlider,
  },
  data() {
    return {
      totalPage: 0,
      issueData: {},
      current: { cover: "" },
      coverInd: 0,
      cover: "",
      cache: {},
      loading: false,
      showsilder: false,
      full: false,
      scale: 0,
      size: 1,
    };
  },
  computed: {
    issueId() {
      return this.$route.params.issueId;
    },
    brandCode() {
      return this.$route.params.brandCode;
    },
    pageNo() {
      if (this.$route.params.pageNo == undefined) return 1;
      else return Number(this.$route.params.pageNo);
    },
    hasnext() {
      if (this.pageNo == -1) return true;
      const maxPage = this.issueData.pageTotal;
      return maxPage > this.pageNo;
    },
    haspre() {
      return this.pageNo > -1;
    },
    coverheight() {
      if (this.full) {
        const ele = document.querySelector("#cover>img");
        return Math.round((ele.naturalHeight * this.size) / 100) + "px";
      } else {
        return undefined;
      }
    },
  },
  async created() {
    await this.loadIssuseData();

    //mnid
    if (!isNaN(this.pageNo)) {
      await this.loadCurrentPager();
    }
  },
  methods: {
    initscale() {
      const ele = document.querySelector("#cover>img");
      this.scale = ele.height / ele.naturalHeight;
      this.size = Math.round(this.scale * 100);
    },
    swithFull() {
      this.full = !this.full;
    },
    loadIssuseData: async function () {
      let data = getCacheIssue(this.issueId);
      if (data == undefined || data === "{}") {
        this.loading = true;
        const rps = await get(API.magz.brand.issue(this.issueId), {
          issueId: this.issueId,
          brandCode: this.brandCode,
        });
        if (rps.errMsg == API.Code.ok) {
          data = rps.data;
          cacheIssue(this.issueId, rps.data);
        }
        this.loading = false;

        this.loadPages(data.pageList);
      }
      this.issueData = data;

      // //mnid
      // if (isNaN(this.pageNo)) {
      //   const mnid = this.$route.params.pageNo;
      //   const ind = data.pageList.findIndex((x) => x.mnId == mnid);
      //   this.$router.replace(
      //     `/read/${this.brandCode}/${this.issueId}/${ind > -1 ? ind : -1}`
      //   );
      // }
    },

    loadPages: async function (list) {
      list.forEach((item) => {
        get(API.magz.brand.chapter(item.mnId)).then((rps) => {
          if (rps.errMsg == API.Code.ok) {
            var chapter = rps.data;
            chapter.pages.forEach((url) => {
              sessionStorage.setItem(
                url,
                JSON.stringify({
                  title: chapter.title,
                  mgName: chapter.mgName,
                  issueNo: chapter.issueNo,
                  htmlContent: chapter.htmlContent,
                  mnId: chapter.mnId,
                  issueId: chapter.issueId,
                })
              );
              if (url == this.cover) this.loadCurrentPager();
            });
          }
        });
      });
    },
    loadCurrentPager: async function () {
      if (this.pageNo < 1) {
        this.current = {};
        this.cover = this.issueData.cover;
        return;
      } else {
        this.cover =
          this.issueData.urlPrefix.replace(/\/$/, "") +
          "/" +
          this.pageNo.toString().padStart(3, "0") +
          ".jpg";

        var current = JSON.parse(sessionStorage.getItem(this.cover) || "{}");

        if (current.issueId) {
          head(
            bookAPI.magz.log(
              this.brandCode,
              current.mgName,
              current.issueNo,
              current.issueId,
              current.mnId
            )
          );
        }

        this.current = current;
      }
    },
    pre() {
      if (!this.haspre || this.loading) return;
      this.$router.push(
        `/read/${this.brandCode}/${this.issueId}/${this.pageNo - 1}`
      );
    },
    next() {
      if (this.loading || !this.hasnext) return;
      this.$router.push(
        `/read/${this.brandCode}/${this.issueId}/${this.pageNo + 1}`
      );
    },
    switchSilder() {
      this.showsilder = !this.showsilder;
    },
  },
  watch: {
    pageNo() {
      this.loadCurrentPager();
    },
  },
};
</script>

<style scoped>
.pager {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: calc(100vh - 0.8rem);
  margin-top: 0.8rem;
  transition: all 0.3s ease-out;
}

.iconfont {
  color: #777777;
  font-size: 0.6rem;
}

.pager .actable {
  /* width: 0.33rem; */
  margin: 0 0.4rem;
}

.magcontent {
  /* min-width: 4rem;
  min-height: 6rem;*/
  max-width: 80vw;
  height: 100%;
  box-shadow: 0px 0px 5px 0px rgba(132, 132, 132, 0.5);
}

.page {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.sizebar {
  display: none;
}

.fullscreen {
  position: fixed;
  overflow: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 13;
  margin: 0;
  max-width: 100vw;
  background-color: #777777;
  transition: all 0.3s ease-in;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  text-align: center;
  display: block;
}

.fullscreen .iconfont {
  color: #fff;
  position: fixed;
  top: calc(50vh - 0.3rem);
  z-index: 20;
  background: rgba(80, 80, 80, 0.4);
  border-radius: 0.4rem;
  line-height: 2;
}

.fullscreen .iconpre {
  left: 0.4rem;
}

.fullscreen .iconnext {
  right: 0.4rem;
}

.fullscreen .magcontent {
  max-width: none;
}

.fullscreen .sizebar {
  position: fixed;
  bottom: 20px;
  /* right: calc(100vh - 50px); */
  right: 20px;
  display: inline-block;
  width: 100px;
  background: rgba(80, 80, 80, 0.4);
  border-radius: 10px;
  padding: 0 8px;
  z-index: 99;
}

.hidden {
  visibility: hidden;
}
</style>